import { render, staticRenderFns } from "./epb-switch.component.vue?vue&type=template&id=0d12c9a5&scoped=true"
import script from "./epb-switch.component.vue?vue&type=script&lang=ts"
export * from "./epb-switch.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-switch.component.vue?vue&type=style&index=0&id=0d12c9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12c9a5",
  null
  
)

export default component.exports